<div class="spinner" *ngIf="showSpinner">
    <div class="spinner-inner"></div>
</div>